import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  Output,
  EventEmitter,
  ViewEncapsulation,
  ElementRef,
} from '@angular/core';
import { Subject } from 'rxjs';
import { FnCheckboxFilterItem } from './fn-checkbox-filter.model';

@Component({
  selector: 'fn-checkbox-filter',
  templateUrl: 'fn-checkbox-filter.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class FnCheckboxFilterComponent implements OnInit, OnDestroy {
  @Input() isGrouping: boolean | string;
  @Input() listItemArray: Array<FnCheckboxFilterItem> = [];
  @Output() cbSelectedItem = new EventEmitter();
  @Input() updateSelectedSub: Subject<any>;
  @Input() defaultDesc = 'Filter';
  @Input() appendTo = '';

  description = 'Filter';
  uiFilterArray: Array<FnCheckboxFilterItem> = [];
  searchInput = '';
  showDropDown = false;
  selectedMap: Map<string, Map<string, string>>;

  constructor(private elementRef: ElementRef) {
    this.selectedMap = new Map();
  }

  closeDropDown() {
    if (this.showDropDown) {
      this.showDropDown = false;
    }
  }


  ngOnInit() {
    if (this.updateSelectedSub) {
      this.updateSelectedSub.subscribe((updatedObj) => {
        this.selectedMap.clear();
        this.selectedMap = updatedObj.updateMap;
        this.listItemArray = updatedObj.listItemArray;
        this.searchInput = '';
        this.uiFilterArray = this.listItemArray;
        this.setDescription();
      });
    }
    this.uiFilterArray = this.listItemArray;
    this.setDescription();
  }

  ngOnDestroy() {
    if (this.updateSelectedSub) {
      this.updateSelectedSub.unsubscribe();
    }
  }

  toggleSelect(event: Event, toggelValue: boolean) {
    this.showDropDown = toggelValue;
    event.stopPropagation();
    event.stopImmediatePropagation();
  }





  refreshSearch() {
    if (this.searchInput) {
      this.searchInput = '';
      this.uiFilterArray = this.listItemArray;
    }
  }

  setDescription() {
    if (this.selectedMap.size > 1) {
      this.description = this.selectedMap.size + ' ' + 'options selected';
    } else if (this.selectedMap.size === 1) {
      const firstIndex = Array.from(this.selectedMap)[0];
      for (let i = 0; i < this.uiFilterArray.length; i++) {
        if (this.uiFilterArray[i].id === firstIndex[0]) {
          this.description = this.uiFilterArray[i].description;
          break;
        }
      }
    } else {
      this.selectedMap.clear();
      this.description = this.defaultDesc;
    }
  }
  // this function execute when Select all of clear
  selectAction(isSelectAll: boolean) {
    if (isSelectAll) {
      if (this.isGrouping) {
        for (let i = 0; i < this.uiFilterArray.length; i++) {
          const childMap: Map<string, string> = new Map();
          this.uiFilterArray[i].isSelected = true;
          for (let j = 0; j < this.uiFilterArray[i].childArray.length; j++) {
            this.uiFilterArray[i].childArray[j].isSelected = true;
            childMap.set(
              this.uiFilterArray[i].childArray[j].id,
              this.uiFilterArray[i].childArray[j].id
            );
          }
          this.selectedMap.set(this.uiFilterArray[i].id, childMap);
        }
      } else {
        for (let i = 0; i < this.uiFilterArray.length; i++) {
          this.uiFilterArray[i].isSelected = true;
          this.selectedMap.set(this.uiFilterArray[i].id, new Map());
        }
      }
      if (this.selectedMap.size > 1) {
        this.description = this.selectedMap.size + ' ' + 'options selected';
      }
    } else {
      this.uiFilterArray.forEach((_item) => {
        _item.isSelected = false;
      });

      if (this.isGrouping) {
        for (let i = 0; i < this.uiFilterArray.length; i++) {
          this.uiFilterArray[i].isSelected = false;
          for (let j = 0; j < this.uiFilterArray[i].childArray.length; j++) {
            this.uiFilterArray[i].childArray[j].isSelected = false;
          }
        }
        this.searchInput = '';
        this.uiFilterArray = this.listItemArray;
      }
      this.selectedMap.clear();
      this.description = 'Filter';
      this.refreshSearch();
    }
    this.cbSelectedItem.emit(this.selectedMap);
  }

  // this function is execute when select  parent
  selectParent(uiItem: FnCheckboxFilterItem) {
    const _id = uiItem.id;
    if (this.selectedMap.has(_id)) {
      this.selectedMap.delete(_id);
    }

    if (uiItem.isSelected) {
      uiItem.isSelected = false;
      if (this.isGrouping && uiItem.childArray) {
        for (let i = 0; i < uiItem.childArray.length; i++) {
          uiItem.childArray[i].isSelected = false;
        }
      }
    } else {
      uiItem.isSelected = true;
      const childMap: Map<string, string> = new Map();
      if (this.isGrouping && uiItem.childArray) {
        for (let i = 0; i < uiItem.childArray.length; i++) {
          uiItem.childArray[i].isSelected = true;
          childMap.set(uiItem.childArray[i].id, uiItem.childArray[i].id);
        }
      } else {
        childMap.set(_id, _id);
      }
      this.selectedMap.set(_id, childMap);
    }
    this.setDescription();
    this.cbSelectedItem.emit(this.selectedMap);
  }

  onSearch(event: any) {
    const search = event.target.value.toLowerCase();
    if (search !== '') {
      if (this.isGrouping) {
        this.uiFilterArray = [];
        // this loop iterate the array and first find value in parent and if not found then find in child array
        for (let i = 0; i < this.listItemArray.length; i++) {
          const listItem = this.listItemArray[i];
          if (listItem.description.toLowerCase().indexOf(search) !== -1) {
            // here we have assign copy of object to to uifilterarray
            this.uiFilterArray.push(Object.assign([], listItem));
          } else {
            const childItem = listItem.childArray.filter(
              (item) => item.description.toLowerCase().indexOf(search) !== -1
            );
            if (childItem.length > 0) {
              this.uiFilterArray.push(Object.assign([], listItem));
              this.uiFilterArray[
                this.uiFilterArray.length - 1
              ].childArray = childItem;
            }
          }
        }
      } else {
        this.uiFilterArray = this.listItemArray.filter(
          (item) => item.description.toLowerCase().indexOf(search) !== -1
        );
      }
    } else {
      this.uiFilterArray = this.listItemArray;
    }
  }

  // this function is used for select and unselect the child item
  selectChildItem(childVal: FnCheckboxFilterItem, childParentId: string) {
    for (let i = 0; i < this.uiFilterArray.length; i++) {
      if (this.uiFilterArray[i].id === childParentId) {
        for (let j = 0; j < this.uiFilterArray[i].childArray.length; j++) {
          if (this.uiFilterArray[i].childArray[j].id === childVal.id) {
            if (this.uiFilterArray[i].childArray[j].isSelected === false) {
              this.uiFilterArray[i].childArray[j].isSelected = true;
              // this condition is execute when selected Map has child parent id
              if (this.selectedMap.has(childParentId)) {
                const val = this.selectedMap.get(childParentId);
                val.set(childVal.id, childVal.id);
                if (this.uiFilterArray[i].childArray.length === val.size) {
                  this.uiFilterArray[i].isSelected = true;
                }
              } else {
                // this condition is execute when selected Map not have child parent id
                this.selectedMap.set(
                  childParentId,
                  new Map<string, string>().set(childVal.id, childVal.id)
                );
                if (
                  this.uiFilterArray[i].childArray.length ===
                  this.selectedMap.get(childParentId).size
                ) {
                  this.uiFilterArray[i].isSelected = true;
                }
              }
            } else {
              this.uiFilterArray[i].isSelected = false;
              this.uiFilterArray[i].childArray[j].isSelected = false;
              this.selectedMap.get(childParentId).delete(childVal.id);
              if (this.selectedMap.get(childParentId).size === 0) {
                this.selectedMap.delete(childParentId);
              }
            }
          }
        }
      }
    }
  }
}
